import React, { FC, useMemo, useRef, useState } from 'react';

//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import AppFieldBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { NumberBox, SelectBox, TextArea } from 'devextreme-react';
import $createDataSource from 'utils/create-data-souce-instance';
import { rtkCallback } from 'utils/rtkCallback';

import { useGetMethodOfReceptionListQuery } from 'bus/methodOfReception/services';
import {
  useChangeRequestWorkMutation,
  useCreateRequestWorkMutation,
  useGetRequestQuery,
  useLazyGetRequestWorkQuery,
} from 'bus/request';
import { CreateWorkRequest } from 'bus/request/types';

const initialForm: CreateWorkRequest = {
  id: null,
  transportId: null,
  driverId: null,
  quantity: undefined,
  printQuantity: undefined,
  methodOfReceptionId: undefined,
  comment: '',
};

type Props = {
  requestId: number;
  requestWorkId: number;
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
  type: 'CREATE' | 'EDIT';
};

const AdditionalCreateWorkRequestModal: FC<Props> = (props) => {
  const storeTransport: any = useMemo(() => {
    const defaultFilter = ['id', '>', '0'];
    return $createDataSource<CreateWorkRequest>('/v1/Transport', 'id', { defaultFilter });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.requestId]);

  const { data: requestData } = useGetRequestQuery({ id: props.requestId });

  const [getRequestWork] = useLazyGetRequestWorkQuery();
  const { data: methodOfReceptionList } = useGetMethodOfReceptionListQuery({ requestId: props.requestId });
  const [createRequestWork, { isLoading: isLoadingCreate, reset: resetCreate }] = useCreateRequestWorkMutation();
  const [changeRequestWork, { isLoading: isLoadingChange, reset: resetChange }] = useChangeRequestWorkMutation();

  const disabledSubmit = isLoadingCreate || isLoadingChange;

  const storeEmployee: any = useMemo(() => {
    const defaultFilter = [['postId', '>=', 1], 'and', ['postId', '<=', 2]];
    return $createDataSource('/v1/employee', 'id', { defaultFilter });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.requestId]);

  const [form, setForm] = useState<CreateWorkRequest>({
    ...initialForm,
    comment: requestData?.comment || '',
  });

  let formSubmit = useRef<Form>(null);
  let validateRef = useRef<ValidationGroup>(null);

  const fetchSuccess = () => {
    props.refresh();
    props.changeVisible(false);
    resetCreate();
    resetChange();
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();

    if (validateRef.current?.instance.validate().isValid) {
      if (props.type === 'EDIT') {
        const dataRequest = {
          ...form,
          id: props.requestWorkId,
          type: 1,
        };
        changeRequestWork(dataRequest).then((r) => rtkCallback(r, fetchSuccess));
      } else {
        const dataRequest = {
          ...form,
          parentId: props.requestWorkId,
          id: props.requestId,
          type: 1,
        };
        createRequestWork(dataRequest).then((r) => rtkCallback(r, fetchSuccess));
      }
    }
  };

  const onShown = async () => {
    validateRef.current?.instance.reset();

    if (props.requestWorkId) {
      setForm((prev) => ({
        ...prev,
        parentId: props.requestWorkId,
        comment: requestData?.comment || '',
      }));
      const result = await getRequestWork({ id: props.requestWorkId });

      ///при создании нужно сбросить объемы
      const resetQuantity = props.type === 'EDIT' ? {} : { quantity: 0, printQuantity: 0 };

      setForm({ ...result.data!, ...resetQuantity });
    } else {
      setForm((prev) => ({
        ...prev,
        id: +props.requestId,
        comment: requestData?.comment || '',
      }));
    }
  };

  const onHidden = () => {
    setForm(initialForm);
    validateRef.current?.instance.reset();
  };

  return (
    <div>
      <Popup
        visible={props.visible}
        onHiding={() => props.changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title={props.type === 'EDIT' ? 'Редактирование аварийной догрузки' : 'Создание аварийной догрузки'}
        width={400}
        onShowing={onShown}
        onHidden={onHidden}
        height="auto"
      >
        <div className="modal-block">
          <form onSubmit={handleSubmit}>
            <div className="modal-block__content">
              <ValidationGroup ref={validateRef}>
                <Form formData={form} ref={formSubmit}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppFieldBox label="Транспорт" labelTop>
                      <SelectBox
                        stylingMode="underlined"
                        placeholder="Выберите транспорт"
                        mode="text"
                        value={form.transportId}
                        onValueChange={(e) => {
                          setForm((prev) => ({ ...prev, transportId: e }));
                        }}
                        searchMode="contains"
                        searchExpr="fullName"
                        searchEnabled
                        displayExpr="fullName"
                        valueExpr="id"
                        //dataSource={storeTransport.data.map((i: any) => i.id > 0)}
                        dataSource={storeTransport}
                        readOnly
                      >
                        <Validator>
                          <RequiredRule message="Выберите транспорт" />
                        </Validator>
                      </SelectBox>
                    </AppFieldBox>
                    <AppFieldBox label="Водитель" labelTop>
                      <SelectBox
                        stylingMode="underlined"
                        placeholder="Выберите водителя"
                        mode="text"
                        value={form.driverId}
                        onValueChange={(e) => {
                          setForm((prev) => ({ ...prev, driverId: e }));
                        }}
                        searchMode="contains"
                        searchExpr="fullName"
                        searchEnabled
                        displayExpr="fullName"
                        valueExpr="id"
                        readOnly
                        dataSource={storeEmployee}
                      ></SelectBox>
                    </AppFieldBox>

                    <AppFieldBox label="Объём на печать (куб.)" labelTop>
                      <NumberBox
                        stylingMode="underlined"
                        placeholder="Объём на печать"
                        //mode="text"
                        format="###0.##"
                        value={form.printQuantity}
                        onValueChanged={(e) => {
                          setForm((prev) => ({ ...prev, printQuantity: e.value }));
                        }}
                        min={0.5}
                      >
                        <Validator>
                          <RequiredRule message="Заполните поле Объём на печать" />
                        </Validator>
                      </NumberBox>
                    </AppFieldBox>

                    <AppFieldBox label="Фактический объём (куб.)" labelTop>
                      <NumberBox
                        stylingMode="underlined"
                        placeholder="Введите фактический объём"
                        //mode="text"
                        format="###0.##"
                        value={form.quantity}
                        onValueChanged={(e) => {
                          setForm((prev) => ({ ...prev, quantity: e.value }));
                        }}
                        min={0.5}
                      >
                        <Validator>
                          <RequiredRule message="Заполните поле Объём" />
                        </Validator>
                      </NumberBox>
                    </AppFieldBox>

                    <AppFieldBox label="Метод приёма" labelTop>
                      <SelectBox
                        stylingMode="underlined"
                        placeholder="Выберите метод приёма"
                        mode="text"
                        value={form.methodOfReceptionId}
                        onValueChange={(e) => {
                          setForm((prev) => ({ ...prev, methodOfReceptionId: e }));
                        }}
                        searchMode="contains"
                        searchExpr="displayName"
                        searchEnabled
                        displayExpr="displayName"
                        valueExpr="id"
                        //dataSource={storeTransport.data.map((i: any) => i.id > 0)}
                        dataSource={methodOfReceptionList}
                      >
                        <Validator>
                          <RequiredRule message="Выберите метод приёма" />
                        </Validator>
                      </SelectBox>
                    </AppFieldBox>

                    <AppFieldBox label="Комментарий" labelTop>
                      <TextArea
                        stylingMode="underlined"
                        placeholder="Комментарий"
                        mode="text"
                        value={form.comment}
                        onValueChange={(e: any) => {
                          setForm((prev: any) => ({ ...prev, comment: e }));
                        }}
                      ></TextArea>
                    </AppFieldBox>

                    <ModalFooter
                      useSubmitBehavior={false}
                      handleSubmit={handleSubmit}
                      hideModal={() => props.changeVisible(false)}
                      disabledSubmit={disabledSubmit}
                    />
                  </Item>
                </Form>
              </ValidationGroup>
            </div>
          </form>
        </div>
      </Popup>
    </div>
  );
};

export default AdditionalCreateWorkRequestModal;
